<template>
  <div>
    <Header/>
    <m-update-site-message-1/>
    <slot/>
    <whats-app-btn/>
    <Footer/>
  </div>
</template>
<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import WhatsAppBtn from "../../components/WhatsAppBtn";

export default {
  name: "SiteLayout",
  components: {Header, Footer, WhatsAppBtn,},
}
</script>

<style scoped>

</style>